import {
  AddPADParams,
  AddPaymentMethodParams,
  AppModalStackParams,
  OrderInboundsStackParams,
} from '@/navigators/types';
import { APP_MODAL_ROUTES, ORDER_INBOUNDS_ROUTES } from '@/navigators/routes';
import {
  CompositeNavigationProp,
  useNavigation,
} from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { TabCardDetails } from '@/components/payments/types';
import { useCallback } from 'react';
import { useOrderInboundsStore } from '@/stores/order-inbounds-store';

type Navigation = CompositeNavigationProp<
  StackNavigationProp<AppModalStackParams, APP_MODAL_ROUTES.AddPaymentMethod>,
  StackNavigationProp<
    OrderInboundsStackParams,
    ORDER_INBOUNDS_ROUTES.AddPaymentMethod
  >
>;

// Inbounds stack is a sibling of the app stack. Navigate to the correct stack
// based on whether or not the user is in order agent.
export const useWalletNavigation = () => {
  const navigation = useNavigation<Navigation>();

  const navigateToAddPaymentMethod = useCallback(
    (params: AddPaymentMethodParams) => {
      if (useOrderInboundsStore.getState().isInOrderInboundsStack) {
        navigation.navigate(ORDER_INBOUNDS_ROUTES.AddPaymentMethod, params);
      } else {
        navigation.navigate(APP_MODAL_ROUTES.AddPaymentMethod, params);
      }
    },
    [navigation],
  );

  const navigateToAddPAD = useCallback(
    (params: AddPADParams) => {
      if (useOrderInboundsStore.getState().isInOrderInboundsStack) {
        navigation.navigate(ORDER_INBOUNDS_ROUTES.AddPAD, params);
      } else {
        navigation.navigate(APP_MODAL_ROUTES.AddPAD, params);
      }
    },
    [navigation],
  );

  const navigateToTabCardApplication = useCallback(
    (params: TabCardDetails) => {
      if (useOrderInboundsStore.getState().isInOrderInboundsStack) {
        navigation.navigate(ORDER_INBOUNDS_ROUTES.TabCardApplication, params);
      } else {
        navigation.navigate(APP_MODAL_ROUTES.TabCardApplication, params);
      }
    },
    [navigation],
  );

  return {
    navigateToAddPAD,
    navigateToAddPaymentMethod,
    navigateToTabCardApplication,
  };
};
